import { createUUID } from "../../../utils"

export * from './palette-nodes';
export * from './node-factory';

export const getIfElseNodeDataTemplate = () => ({
  conditions: [
    {
      condition: '',
      conditionObj: { rules: [] },
      target: '',
      edge_uid: createUUID()
    }
  ],
  else_target: '',
  attribute: ''
})
